import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const publishableKey =
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY ||
  process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(url && publishableKey);
// Demo mode is an explicit local-development opt-in. A missing Supabase
// configuration must never silently turn a production build into a role
// preview with a client-side authenticated session.
export const isDemoModeEnabled =
  process.env.NODE_ENV !== "production" &&
  process.env.REACT_APP_ENABLE_DEMO_MODE === "true";

/**
 * Custom fetch that uses the native browser fetch captured before any
 * third-party script (PostHog session recording, Emergent preview wrapper)
 * had a chance to patch `window.fetch`. Without this, Supabase's SDK hits:
 *   "Failed to execute 'json' on 'Response': body stream already read"
 * because the wrapper consumes the body stream first.
 *
 * `public/index.html` stashes the reference on `window.__nativeFetch`.
 */
const cleanFetch =
  (typeof window !== "undefined" && window.__nativeFetch) ||
  (typeof globalThis !== "undefined" && typeof globalThis.fetch === "function"
    ? globalThis.fetch.bind(globalThis)
    : undefined);

/**
 * No-op navigator.locks replacement. Supabase-js uses the Web Locks API to
 * serialize session access across tabs. In some embedded/preview browser
 * contexts the lock never resolves and `getSession()` hangs forever. This
 * app is single-instance per tab so serialisation isn't needed.
 */
const noopLock = async (_name, _acquireTimeout, fn) => {
  return await fn();
};

export const supabase = isSupabaseConfigured
  ? createClient(url, publishableKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        lock: noopLock,
      },
      global: cleanFetch ? { fetch: cleanFetch } : undefined,
    })
  : null;
